module.exports = __webpack_public_path__ + "img/xishi_QrCode.e749cbd2.jpg";